import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-confirm-registration',
  templateUrl: './confirm-registration.component.html',
  styleUrl: './confirm-registration.component.scss',
})
export class ConfirmRegistrationComponent {
  loading = true;
  expired = false;
  /** Any failure that is not an expired/invalid token — 5xx, network, CORS. */
  failed = false;
  resendEmail = '';
  resendLoading = false;
  resendSuccess = false;
  resendError = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    http: HttpClient
  ) {
    const token = this.router.parseUrl(this.router.url).queryParams['token'];

    authService.confirmRegistration(token).subscribe({
      next: () => {
        this.loading = false;
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.status === 400) {
          this.expired = true;
          return;
        }
        // Anything else — 5xx, a dropped connection, CORS — used to leave
        // both flags false, and the template's only other branch is the
        // success state. So a server error rendered as "Registration
        // confirmed", the account stayed unconfirmed, and the next login
        // returned 401 with nothing explaining why. Fail visibly and offer
        // the same resend form instead.
        this.failed = true;
      },
    });
  }

  onLogin() {
    this.router.navigate(['/auth/login']);
  }

  onResend() {
    if (!this.resendEmail) return;
    this.resendLoading = true;
    this.resendError = '';
    this.resendSuccess = false;

    this.authService.resendConfirmation(this.resendEmail).subscribe({
      next: () => {
        this.resendLoading = false;
        this.resendSuccess = true;
      },
      error: (err: HttpErrorResponse) => {
        this.resendLoading = false;
        // 429 means the cooldown is still running — that is a "wait a
        // moment", not a failure, and must not read like a dead end.
        this.resendError =
          err.status === 429
            ? 'pages.confirmRegistration.resendCooldown'
            : 'pages.confirmRegistration.resendError';
      },
    });
  }
}
